import React, {FC} from 'react'
import {Trans, useTranslation} from 'react-i18next'

import {Box, Typography} from '@mui/material'

import {ReactComponent as ExpiredImage} from '@progyny/assets/images/expired.svg'
import loginPicPng from '@progyny/assets/images/side-banner-white-top.png'
import {SidepanelContainer} from '@progyny/components/SidepanelContainer'
import SimpleMessageContainer from '@progyny/components/SimpleMessageContainer'

import {theme} from '@root/theme'

const CannotSignUpPage: FC = () => {
  const {t} = useTranslation()

  return (
    <SidepanelContainer
      styleProps={{
        backgroundPicSrc: loginPicPng,
        backgroundColor: theme.palette.primary.main,
        logoColor: 'primary',
      }}
      mainComponent={
        <SimpleMessageContainer
          image={ExpiredImage}
          message={
            <Box>
              <Typography variant={'h1'}>
                {t('cannot-sign-up_it_s_not_you_it')}
              </Typography>
              <Typography variant={'body1'} mt={2}>
                <Trans i18nKey='cannot-sign-up_your_account_will_be_activated' />
              </Typography>
            </Box>
          }
        />
      }
    />
  )
}

export default CannotSignUpPage
